/* eslint-disable */
import { useMemo } from "react";
import { useCalendarValue } from "./useCalendarValue";
import { useCalendarMultiple } from "./useCalendarMultiple";
import { ICalendarSelectorGroup } from "../types";

export function useApplay(groups: ICalendarSelectorGroup[], setValue: (val: string | string[] | null) => void) {
  const multiple = useCalendarMultiple();

  return useMemo(() => {
    const val = groups
          .map((g) => g.items)
          .reduce((acc, val) => acc.concat(val), [])
          .filter((i) => i.active)
          .map((i) => i.item.id);
 
    return () => {
      const values = groups
          .map((g) => g.items)
          .reduce((acc, val) => acc.concat(val), [])
          .filter((i) => i.active)
          .map((i) => i.item.id);
      if (multiple) {
        setValue(values);
      } else {
        setValue(values[0]);
      }
    };
  }, [groups, setValue]);
}
